import React, { createContext, useContext, ReactNode, useEffect } from 'react';
import { useChatContext } from './AppDataContext';

const KeyContext = createContext<{} | undefined>(undefined);

interface KeyContextProviderProps {
  children: ReactNode;
}

export const KeyContextProvider: React.FC<KeyContextProviderProps> = ({ children }) => {
  const { setIsSearchModalOpen } = useChatContext();

  useEffect(() => {
    const handleGlobalKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setIsSearchModalOpen(prev => !prev);
      }
    };

    window.addEventListener('keydown', handleGlobalKeyDown);
    return () => {
      window.removeEventListener('keydown', handleGlobalKeyDown);
    };
  }, [setIsSearchModalOpen]);

  return (
    <KeyContext.Provider value={{ }}>
      {children}
    </KeyContext.Provider>
  );
};

export const useKeyContext = (): {} => {
  const context = useContext(KeyContext);
  if (!context) {
    throw new Error("useKeyContext must be used within a KeyContextProvider");
  }
  return context;
};